import ClientNavbar from "../components/ClientNavbar";
import Footer from "../components/Footer";
import "../styles/legal.css";

function PrivacyPolicy() {
  return (
    <>
      <ClientNavbar />

      <main className="legal-page">
        <h1>Privacy Policy</h1>

        <p>
          At CompExams, we respect your privacy and are committed to
          protecting your personal information.
        </p>

        <h2>Information We Collect</h2>
        <p>
          When you use our website, we may collect information such as
          your email address and phone number when you make a payment
          or request a paid exam download.
        </p>

        <h2>How We Use Your Information</h2>
        <p>
          We use information provided by users to process payments,
          provide access to purchased exams, communicate about
          transactions, and improve our services.
        </p>

        <h2>Payments</h2>
        <p>
          Payments are processed through our payment provider. We do
          not store your payment card details on our servers.
        </p>

        <h2>Cookies and Advertising</h2>
        <p>
          CompExams may use cookies and similar technologies to
          improve the website and display relevant advertising.
          Third-party advertising providers, including Google
          AdSense, may use cookies to serve advertisements based on
          users' visits to this and other websites.
        </p>

        <h2>Third-Party Services</h2>
        <p>
          Our website may use third-party services for payments,
          advertising, analytics, hosting, and other website
          functions. These services may process information according
          to their own privacy policies.
        </p>

        <h2>Contact Us</h2>
        <p>
          If you have questions about this Privacy Policy, please
          contact us through the Contact page on our website.
        </p>

        <h2>Changes to This Policy</h2>
        <p>
          We may update this Privacy Policy from time to time. Any
          changes will be published on this page.
        </p>
      </main>

      <Footer />
    </>
  );
}

export default PrivacyPolicy;
